import { connect } from 'react-redux';

import * as organizationConstants from '../../constants/organizations';
import RemoveUser from '../../components/RemoveUser';

const mapDispatchToProps = dispatch => ({
    onSubmit: payload =>
        dispatch({
            type: organizationConstants.REMOVE_USERS_REQUEST,
            payload,
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(RemoveUser);



// WEBPACK FOOTER //
// ./src/containers/appDialog/RemoveUserFromOrganization.js